<template>
  <div>
    <childLogo></childLogo>
    <el-row style="min-height: 650px;    background: #f0f0f0;">
      <el-col :lg="4" :md="4" :xs="2" :sm="2">
        <div class="grid-content"></div>
      </el-col>
      <el-col :lg="16" :md="16" :xs="20" :sm="20">
        <div class="grid-content">
          <div v-bind="article" class="article-title">
          
          </div>
          <div style="text-align: left">
            <el-row>
              <el-col :lg="6" :md="6" :xs="12" :sm="12" :id="item.id" v-for="(item, index) in articleData" :key="index">
                 <el-image 
                  class="imageList"
                  :src="item.fileUrl" 
                  :preview-src-list="srcList">
                </el-image>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :lg="4" :md="4" :xs="2" :sm="2">
        <div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";
export default {
  name: "ImageDetail",
  components: {
    ChildLogo: ChildLogo,
  },
  watch: {
    articleId: function () {
      this.handleArticle();
      this.handleArticleImage();
      this.article = undefined;
      // this.articleData = [];
    },
  },
  data() {
    return {
      articleId: undefined,
      article: undefined,
      articleData: [],
      srcList:[]
    };
  },
  created() {
    this.articleId = this.$route.query.id;
  },
  methods: {
      handleArticle() {
      var api = this.siteURL + "/actuator/article/list?id=" + this.articleId;
      this.axios.get(api, {}).then((response) => {
        this.article = response.data.rows[0];
      });
    },
    handleArticleImage() {
      var api = this.siteURL + "/actuator/file/list?articleId=" + this.articleId;
      this.axios.get(api, {}).then((response) => {
        this.articleData = response.data.rows;
        this.articleData.forEach(item =>this.srcList.push(item.fileUrl))
      });
    },
  },
};
</script>

<style scoped>
.grid-content {
  min-height: 600px;
}
.article-title {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
}
.article-author {
  width: 95%;
  height: 60px;
  line-height: 60px;
  text-align: right;
  font-size: 16px;
  margin-right: 30px;
}
 .imageList {
    width: 100%;height:260px;padding:10px;
  }
@media screen and (max-width: 768px) {
  .imageList {
    height:160px !important; 
  }
}
</style>




// WEBPACK FOOTER //
// src/views/ImageDetail.vue